import * as React from "react";
import { SharepointRow } from "@/views/sharepoint/row";
import { useGetSharepointItemsQuery } from "@/api/sharepoint";
import { Loader } from "@/components/ui/loader";
import { useParams } from "react-router";
import { SharepointParentDir } from "@/views/sharepoint/components/parentDir";
import TopBarProgress from "react-topbar-progress-indicator";
import * as Sentry from "@sentry/react";
import * as analytics from "@/services/analytics";

export const SharepointView: React.FC = () => {
  const { "*": fseId = "" } = useParams<{ "*": string }>();

  const { data, isLoading, isFetching, isError, error } = useGetSharepointItemsQuery(fseId.split("/").at(-1));

  React.useEffect(() => {
    if (!isLoading && data?.status === "login_required") {
      analytics.sharepointLogin();
      document.location.href = "/pf-auth/oauth/o365-login";
    }
  }, [isLoading, data]);

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    Sentry.captureException(error);

    return <div>Error occurred while fetching data. Please try again later.</div>;
  }

  return (
    <div className="mx-auto p-8">
      {isFetching && <TopBarProgress />}

      <div className="mb-6 pb-4">
        <div className="mb-2 flex flex-col justify-between space-y-2 sm:flex-row sm:space-y-0">
          <h1 className="text-2xl font-bold">Sharepoint</h1>
        </div>
      </div>
      <div className="divide-y divide-gray-200 rounded-lg bg-white">
        {fseId && <SharepointParentDir />}
        {!isFetching && data?.files.map(file => <SharepointRow key={file.id} item={file} />)}
      </div>
    </div>
  );
};
